/**
 * Fetch da versão do backend público. Reusa o endpoint /version do orya-backend.
 */
const API_BASE = (import.meta.env.VITE_API_URL || 'https://api.oryacrm.com/api/manager')
  // Remove /api/manager pra acessar /version que é raiz
  .replace(/\/api\/manager\/?$/, '');

export interface VersionResponse {
  version: string;
  env: string;
  displayVersion: string;
}

let cached: Promise<VersionResponse | null> | null = null;

export async function fetchBackendVersion(): Promise<VersionResponse | null> {
  if (cached !== null) return cached;
  cached = (async () => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5_000);
      const res = await fetch(`${API_BASE}/version`, {
        method: 'GET',
        credentials: 'include',
        signal: controller.signal,
      });
      clearTimeout(timeoutId);
      if (!res.ok) return null;
      const data = (await res.json()) as VersionResponse;
      return data?.displayVersion != null ? data : null;
    } catch {
      return null;
    }
  })();
  return cached;
}
